import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import styled from "styled-components/macro";

export default function AzureAppServiceNote({ slug }: { slug: string }): JSX.Element {
    if (slug !== "appservices") {
        return null;
    }
    return (<Wrapper aria-label="Azure App Service Information">
        <p> <b>Please note before reporting!</b></p>
        <p>
            <ul>
                <li>Only report portal bugs or feature suggestions on this page.</li>
                <li>For application issues, please use <a href="https://learn.microsoft.com/en-us/azure/app-service/overview-diagnostics" target="_blank" rel="noreferrer">Diagnose and Solve</a> for self serve troubleshooting.  If you need direct help with application issues, please create a support request <a href="https://ms.portal.azure.com/#view/Microsoft_Azure_Support/NewSupportRequestV3Blade/callerWorkflowId/ff9f68ad-28dd-4a70-b184-f0ed93043cab/callerName/Microsoft_Azure_Support%2fHelpAndSupportOverview.ReactView" target="_blank" rel="noreferrer">here</a>.</li>
            </ul>
        </p>
    </Wrapper>);
}

const Wrapper = styled.div`
    padding: 2rem;
    margin: 2rem 0;
    border: 0.1rem solid var(--color-info);
    border-top: 0.4rem solid var(--color-info);
    border-radius: 0.2rem;
    box-shadow: 0px 0.3px 0.9px rgb(0 0 0 / 11%),0px 1.6px 3.6px rgb(0 0 0 / 13%);
    background-color: var(--color-surface);

    ul {
        padding-inline-start: 4rem;
        margin-block-start: 1em;
        margin-block-end: 1em;

        li {
            display: list-item;
        }
    }
`;
